import { TinyBarChart } from '@procureai/ui-mui';
import { PropsWithChildren } from 'react';

import { CubeChartBaseProps } from '../CubeChart.types';

export const CubeChartBarTiny = <TData extends Record<string, any>>({
  resultSet,
  formatter,
}: PropsWithChildren<CubeChartBaseProps<TData>>) => {
  const segments = resultSet.series()?.[0]?.series;

  if (segments) {
    return (
      <TinyBarChart
        value={segments}
        height={52}
        color="chartPrimary"
        getBarValue={(bar: any) => (bar.value < 0 ? 0 : bar.value)}
        getBarLabel={(bar: any) => {
          const x = formatter?.x ? formatter.x(bar.x) : bar.x;
          const val = formatter?.y ? formatter.y(bar.value) : bar.value;
          return `${x}: ${val}`;
        }}
      />
    );
  }

  return null;
};
